import { SITE_TEXTS_GRID_NAME } from '../constants';


export const getSiteTextsGridName = langKey => `${SITE_TEXTS_GRID_NAME}_${langKey}`;
